import { useTranslation } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { ScatterPlotWithRegressionLine } from '../ScatterPlotWithRegressionLine'
import { AVG_BUY_PRICES_NEU_BESTAND } from './data/durchschnittliche_kaufpreise_neu_bestand'
import { useDataForScatterPlotGraph } from './libs/useDataForScatterPlotGraph'

export interface RegionAvgBuyPricesScatterPlotProps {
  customProps: RegionAvgBuyPricesScatterPlotCustomProps
}

export type RegionAvgBuyPricesScatterPlotCustomProps = {
  region: string
}

export const RegionAvgBuyPricesScatterPlot: FunctionComponent<React.PropsWithChildren<RegionAvgBuyPricesScatterPlotProps>> = ({ customProps }) => {
  const region = customProps.region
  const t = useTranslation()
  const {
    finalData_neubau,
    finalData_bestand,
    regressionLineValues_neubau,
    regressionLineValues_bestand,
  } = useDataForScatterPlotGraph(region, AVG_BUY_PRICES_NEU_BESTAND, 'kauf')

  const data = [
    {
      id: t('accentro:districtLandingPageGraphs.regionAverageGraph.newBuild'),
      data: finalData_neubau,
      lineValues: regressionLineValues_neubau,
    },
    {
      id: t(
        'accentro:districtLandingPageGraphs.regionAverageGraph.existingBuilding'
      ),
      data: finalData_bestand,
      lineValues: regressionLineValues_bestand,
    },
  ]

  if (region) {
    return (
      <ScatterPlotWithRegressionLine
        data={data}
        title={`${t(
          'accentro:districtLandingPageGraphs.candleStickGraph.averagePurchasePrice'
        )} ${region}`}
        titleSubject={t(
          'accentro:districtLandingPageGraphs.candleStickGraph.purchasePrice'
        )}
        rangeStep={2000}
      />
    )
  } else
    return (
      <>
        {t(
          'accentro:districtLandingPageGraphs.regionPieChart.mustSelectRegion'
        )}
      </>
    )
}
